import { RefObject, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectTimelineFocusDate,
  setTimelineFocusDate,
} from '../../../redux/store/ui/common';
import { DAYS_BEFORE_FOCUS } from '../constants';
import { TimelineViewModel } from '../types';

const useFocusScroll = (
  scrollRef: RefObject<HTMLDivElement>,
  vm: TimelineViewModel
) => {
  const dispatch = useDispatch();
  const focusDate = useSelector(selectTimelineFocusDate);

  useEffect(() => {
    if (!focusDate) return;
    const el = scrollRef.current;
    if (!el) return;

    const idx = vm.dayKeys.indexOf(focusDate);
    if (idx < 0) {
      dispatch(setTimelineFocusDate(null));
      return;
    }

    // Place focused day so DAYS_BEFORE_FOCUS earlier days sit at the day-area's
    // left edge (just past the sticky plate column). Today button + Jump-to-date
    // both go through here, so they always land consistently. `dayWidth` = the width
    // of one day at the active zoom (columnsPerDay × columnWidth).
    const dayWidth = vm.columnsPerDay * vm.columnWidth;
    const left = (idx - DAYS_BEFORE_FOCUS) * dayWidth;
    el.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    dispatch(setTimelineFocusDate(null));
  }, [focusDate, vm, dispatch, scrollRef]);
};

export default useFocusScroll;
